// extracted by mini-css-extract-plugin
export default {"NekoSymbol":"styles_NekoSymbol__sNG+w"};